import React from 'react'
import { StatusIndicatorStyles } from './StatusIndicator.styles'
import { StatusIndicatorPropTypes } from './StatusIndicator.types'

export const StatusIndicatorComponent: React.FC<StatusIndicatorPropTypes> = (
  props
) => {
  return <StatusIndicatorStyles {...props} />
}
